import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { RouteEnum } from '@enum/route.enum';
import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { useLazyLoadApplicationStatsQuery } from '@hook/stats/stats.hooks';
import { ApplicationInterface } from '@interface/application/application.interface';

export const useOverviewCard = (application: ApplicationInterface) => {
  const { onChange } = useCurrentApplication();
  const navigate = useNavigate();

  const [loadStats, { data: stats }] = useLazyLoadApplicationStatsQuery();

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if ((event.target as HTMLSpanElement)?.className?.includes('dropdown')) return;
      onChange(application.id);
      navigate(RouteEnum.Dashboard.path);
    },
    [application.id, onChange, navigate],
  );

  useEffect(() => {
    loadStats(application.id);
  }, [application.id]);

  return {
    onChange: handleClick,
    consumers: stats?.data.consumers ?? 0,
    requests: stats?.data.apiCalls ?? 0,
    connections: stats?.data.connections ?? 0,
  };
};
